import { FileText } from 'lucide-react';
import React from 'react';

import { MultiSheetImportPage } from '@/features/imports/MultiSheetImportPage';

export const ImportVisasPage = (): React.JSX.Element => (
  <MultiSheetImportPage
    config={{
      moduleKey: 'visa',
      titleSingular: 'visa',
      titlePlural: 'visas',
      routePrefix: 'visas',
      listPath: '/visas',
      ListIcon: FileText,
      invalidateOnSuccess: ['visas', 'visa-pricing-tiers'],
      summaryFieldsBySheet: {
        Visas: ['visaKey', 'name', 'targetCountry'],
        PricingTiers: ['visaKey', 'tierName', 'feePerApplicant'],
      },
    }}
  />
);
